import React, {useEffect, useState} from 'react';
import {Link as RouterLink, useLocation, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar} from '@material-ui/core';
import { useTranslation} from "react-i18next";
import fkz_logo from "../../../../../../assets/logos/fkz_logo.png";
import appsumo_logo from "../../../../../../assets/logos/appsumo_logo.png";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Container from "@material-ui/core/Container";
import {processUrl} from "../../../../../../services/utils";
import {useDispatch} from "react-redux";
import {setlanguage} from "../../../../../../redux/actions/appActions";

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '5px 26px 5px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  },
  logo: {
    height: '50px',
    marginRight: '10px'
  },
  appsumo_logo: {
    height: '25px',
    marginRight: '20px',
    marginTop: '10px'
  },
  image_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
   /* justifyContent: "space-between",*/
    textAlign: "center",
    marginTop: "10px"
  },
  container: {
    display: 'flex',
    height: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },

}));

export const TopBar = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [t, i18n] = useTranslation('common');

  const [values, setValues] = useState( { lang: i18n.language });

  const history = useHistory();

  const query = new URLSearchParams(useLocation().search);

  const [appSumoAccount , setAppSumoAccount] = useState(false);

  const dispatch = useDispatch();

    function applyLanguage(language) {
        setValues({lang: language});
        i18n.changeLanguage(language);
        dispatch(setlanguage(language));
    }

    useEffect(function () {
        const params = {
            lang: query.get("lang")
        };
        if (!!(params.lang)) {
            if ((params.lang).toLowerCase() === 'es' || (params.lang).toLowerCase() === 'en') {
                applyLanguage(params.lang);
            } else {
                let lang = 'en';
                applyLanguage(lang);
            }

        }
    }, []);

  const handleChangeLang = (event) => {
    dispatch(setlanguage(event.target.value));
    setValues(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value
    }));
    document.documentElement.lang = event.target.value;
    if (history.location.pathname === '/conditions-and-terms') {
        history.location.search = `?lang=${event.target.value}`;
    }
  };

  useEffect(function () {
    const value = processUrl(query, 'appSumoEmail');
    if (value) {
        setAppSumoAccount(true);
    }
}, []);

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      position="relative"
      style={{backgroundColor: 'rgba(255,255,255,0.72)', paddingLeft: 'unset', paddingRight:'unset'}}
      >
          <Toolbar className={classes.headerContainer}>
            <Container component="main" maxWidth="lg" className={classes.container}>
              <RouterLink to="/">
              <div className={classes.image_container}>
                <img className={classes.logo}
                     alt="logo flokzu"
                     src={fkz_logo}/>
                {appSumoAccount && (
                  
                    <img className={classes.appsumo_logo}
                       alt="logo appsumo"
                       src={appsumo_logo}/>
                 )}
                  </div>
              </RouterLink>
              <div style={{marginRight: '8%'}}>
                <FormControl className={classes.margin}>
                  <InputLabel id="select-label">{t('app.toolbar.lang')}</InputLabel>
                  <Select
                      labelId="select-label"
                      id="select"
                      value={values.lang}
                      onChange={handleChangeLang}
                      inputProps={{
                        name: "lang",
                        id: "lang-simple"
                      }}
                      input={<BootstrapInput />}>
                    <MenuItem value={'en'} onClick={() => i18n.changeLanguage('en')} >English</MenuItem>
                    <MenuItem value={'es'} onClick={() => i18n.changeLanguage('es')}> Español</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Container>
          </Toolbar>
        </AppBar>
      );
    };

    TopBar.propTypes = {
      className: PropTypes.string
    };
